import axios from "axios";

export interface Device {
  id: string;
  token: string;
  userId: string;
  roonPlatform: string;
  roonVersion: string;
  roonProduct: string;
  language: string;
}

async function registerDevice(device: Device) {
  await axios.post("/2/api/devices", device);
}

export default {
  registerDevice,
};
